var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSoldPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6897 11C21.6897 14.9826 16.3097 21.0219 13.3094 24.0804C12.2202 25.1907 10.4694 25.1907 9.38028 24.0804C6.37991 21.0219 1 14.9826 1 11C1 8.34784 2.0899 5.8043 4.02993 3.92893C5.96996 2.05357 8.60121 1 11.3448 1C14.0884 1 16.7197 2.05357 18.6597 3.92893C20.5998 5.8043 21.6897 8.34784 21.6897 11Z",
    fill: "#AFAEAF",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3447 14C12.1677 14 12.9571 13.6839 13.5391 13.1213C14.1211 12.5587 14.4481 11.7956 14.4481 11C14.4481 10.2044 14.1211 9.44129 13.5391 8.87868C12.9571 8.31607 12.1677 8 11.3447 8C10.5216 8 9.7322 8.31607 9.15019 8.87868C8.56818 9.44129 8.24121 10.2044 8.24121 11C8.24121 11.7956 8.56818 12.5587 9.15019 13.1213C9.7322 13.6839 10.5216 14 11.3447 14Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoldPin);
export default __webpack_public_path__ + "static/media/soldPin.ce6a8ba560fd32f958ced59283224b07.svg";
export { ForwardRef as ReactComponent };